const householdSec2_Object = payload => {
  return {
    type: "householdSec2",
    payload
  };
};

export default householdSec2_Object;
